import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import route from '../../utils/Routes';
import { useAuthContext } from '../../context/AuthContext';

function NprLinkPage() {
    const { ctxtUser, setLoadingScreen } = useAuthContext();
    const navigate = useNavigate();
    const { newProdReqIdStrg } = useParams();

    useEffect(() => {
        setLoadingScreen(true);
        if (newProdReqIdStrg) {
            if (ctxtUser?.isComUser) {
                    navigate(`${route.cNewProdreqinfo}/?newProdReqId=${newProdReqIdStrg}`);
            }
            else {
               navigate(`${route.aNewProdreqinfo}/?newProdReqId=${newProdReqIdStrg}`);
            }
        } else {
            navigate(route.login, { replace: true });
        }
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div>PoLinkPage</div>)
}

export default NprLinkPage